module.exports = __webpack_public_path__ + "/19774a9f9d668eeb98c7610f5e91d7ca.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/Data_validation_icon.svg
 ** module id = 1104
 ** module chunks = 0
 **/